import React from 'react'
import { Box, Group, Text } from '@mantine/core'

export default function LegalNotice() {
  return (
    <Box
      className="w-full py-6"
      style={{
        backgroundColor: '#F8F9FC',
      }}
    >
      <div className="max-w-container-xl mx-auto px-4 lg:px-6">
        <Group gap="sm" align="flex-start" wrap="nowrap">
          <div>
            <Text size="sm" c="dimmed" className="leading-relaxed">
              本报告用于合法合规场景，非中国人民银行征信中心出具的个人征信报告。本服务仅限本人实名认证查询，不支持查询他人信息。报告内容仅供参考，不提供风险评估报告外的贷款等金融服务。
            </Text>
          </div>
        </Group>
      </div>
    </Box>
  )
}
